export const MAX_OFFER_ATTACHMENTS = 5;
export const MAX_OFFER_ATTACHMENT_SIZE = 10 * 1024 * 1024;

const getFileSignature = (file) =>
  `${file?.name || ""}-${file?.size || 0}-${file?.lastModified || 0}`;

const validateAttachment = (file) => {
  if (
    !file?.type?.startsWith("image/") &&
    !file?.type?.startsWith("video/")
  ) {
    return "Veuillez importer uniquement des images ou des vidéos.";
  }
  if (file.size > MAX_OFFER_ATTACHMENT_SIZE) {
    return `La taille maximale est de 10 Mo par pièce jointe (${file.name}).`;
  }
  return "";
};

export const mergeOfferAttachments = ({
  currentAttachments,
  incomingFiles,
  existingCount = 0,
  createObjectURL = (file) => URL.createObjectURL(file),
}) => {
  const attachments = [...currentAttachments];
  const signatures = new Set(
    attachments.map(({file}) => getFileSignature(file)),
  );
  const errors = new Set();

  Array.from(incomingFiles || []).forEach((file) => {
    const validationError = validateAttachment(file);
    if (validationError) {
      errors.add(validationError);
      return;
    }

    const signature = getFileSignature(file);
    if (signatures.has(signature)) {
      errors.add("Ce fichier a déjà été sélectionné.");
      return;
    }

    if (existingCount + attachments.length >= MAX_OFFER_ATTACHMENTS) {
      errors.add(
        `Vous pouvez ajouter au maximum ${MAX_OFFER_ATTACHMENTS} pièces jointes.`,
      );
      return;
    }

    signatures.add(signature);
    attachments.push({
      file,
      imageUrl: createObjectURL(file),
    });
  });

  return {attachments, errors: Array.from(errors)};
};
